import CASTDialogProvider from 'components/shared/modals/CASTDialog/CASTDialogProvider';
import { SessionProvider, useSession, signIn } from 'next-auth/react';
import getConfig from 'next/config';
import AuthorizedApolloProvider from 'utils/graphql/apolloClient';
import { UserContext, UserContextProvider } from './UserContext';
import { ApiServicesContextProvider } from './ApiServicesContext';
import { useContext } from 'react';

const { publicRuntimeConfig } = getConfig();

function WrappedApiServicesContextProvider({ children, pageProps }) {
  const { apiUrl, dataImporterUrl, publicApiUrl, usersApiUrl, arcGISAPIToken } = pageProps;
  const { data: currentSession, status } = useSession();
  const { currentTenantName } = useContext(UserContext);

  if (status == 'unauthenticated' || currentSession?.error === 'RefreshAccessTokenError') {
    signIn('keycloak');
  } else if (status === 'loading') {
    return <p>Loading...</p>;
  } else if (status == 'authenticated' && currentTenantName) {
    return (
      <ApiServicesContextProvider
        apiUrl={apiUrl}
        dataImporterUrl={dataImporterUrl}
        publicApiUrl={publicApiUrl}
        usersApiUrl={usersApiUrl}
        arcGISAPIToken={arcGISAPIToken}
        token={currentSession?.accessToken}
        tenantName={currentTenantName as string}
      >
        {children}
      </ApiServicesContextProvider>
    );
  } else {
  }
}

export default function DashboardProviders({ pageProps, children }) {
  const { session, tenantsApiUrl } = pageProps;

  return (
    <SessionProvider
      session={session}
      basePath={`${publicRuntimeConfig.basePath || ''}/api/auth`}
      refetchInterval={60}
      refetchOnWindowFocus={true}
    >
      <AuthorizedApolloProvider apiUrl={tenantsApiUrl}>
        <UserContextProvider>
          <WrappedApiServicesContextProvider pageProps={pageProps}>
            <CASTDialogProvider>{children}</CASTDialogProvider>
          </WrappedApiServicesContextProvider>
        </UserContextProvider>
      </AuthorizedApolloProvider>
    </SessionProvider>
  );
}
